import React from 'react';

import { flagStyles } from '../settings';

const SvgGQ = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-2064px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgGQ;
